import { render } from "./XueQiuNews.vue?vue&type=template&id=25a09ceb&scoped=true"
import script from "./XueQiuNews.vue?vue&type=script&lang=js"
export * from "./XueQiuNews.vue?vue&type=script&lang=js"

import "./XueQiuNews.vue?vue&type=style&index=0&id=25a09ceb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a09ceb"]])

export default __exports__